import { render, staticRenderFns } from "./GroupAssignModal.vue?vue&type=template&id=3e4bd754&scoped=true&"
import script from "./GroupAssignModal.vue?vue&type=script&lang=js&"
export * from "./GroupAssignModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupAssignModal.vue?vue&type=style&index=0&id=3e4bd754&lang=scss&scoped=true&"
import style1 from "./GroupAssignModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4bd754",
  null
  
)

export default component.exports